var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9836 13.2847L16.775 15.1617C16.6717 16.0914 15.9311 16.8069 15.0056 16.671C13.1682 16.4012 9.95636 15.4132 6.52208 11.979C3.08785 8.54473 2.09946 5.33246 1.82934 3.49478C1.69328 2.56914 2.40881 1.82824 3.33868 1.72492L5.21527 1.51641C6.00793 1.42833 6.77714 1.81961 7.17274 2.5121L7.88472 3.75842C8.33205 4.54146 8.20001 5.52702 7.56233 6.1647L7.54359 6.18344C7.07075 6.65629 6.87119 7.33971 7.18435 7.93056C7.45822 8.44728 7.90982 9.12405 8.64288 9.85712C9.37595 10.5902 10.0527 11.0418 10.5694 11.3157C11.1603 11.6288 11.8437 11.4293 12.3166 10.9564L12.3353 10.9377C12.973 10.3 13.9585 10.1679 14.7416 10.6153L15.9879 11.3273C16.6804 11.7229 17.0717 12.4921 16.9836 13.2847Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.3fd4e3c22bbd6197bdeb0bcf76977bac.svg";
export { ForwardRef as ReactComponent };